module.exports = __webpack_public_path__ + "img/icon-position.e7258f50.svg";